const langSwitchers = document.querySelectorAll('.language-switcher')

$('body').on('click', '.current-lang-btn', function (e) {
  e.preventDefault()

  langSwitchers.forEach(langSwitcher => {
    langSwitcher.classList.toggle('is-opened')
  })

})

$('body').on('click', function (e) {

  if(e.target.classList.contains('lang-switch-link')) return true
  if(e.target.classList.contains('current-lang-btn')) return true

  let isLangSwitcherOpen = false

  langSwitchers.forEach(langSwitcher => {
    if(langSwitcher.classList.contains('is-opened')) { isLangSwitcherOpen = true }
  })

  if(isLangSwitcherOpen) {

    langSwitchers.forEach(langSwitcher => {
      langSwitcher.classList.remove('is-opened')
    })

    return false
  }

})
